/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { PRODUCT_NAME } from 'config';
import useStyles from './style';

export default function NotSupportedEngineMessage() {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box
        color="text.secondary"
        p={1}
        border={1}
        borderRadius={10}
        boxSizing="border-box"
        className={classes.bannerOut}
      >
        <FormattedMessage
          id="pages.login.Login.banner.text"
          defaultMessage={
            'To get the best experience of {productName},' +
            ' we recommend you to try it with {chrome} or {ff} web browsers'
          }
          values={{
            productName: PRODUCT_NAME,
            chrome: <b>Chrome</b>,
            ff: <b>Firefox</b>,
          }}
        />
      </Box>
    </Box>
  );
}
